import React, { useRef, useEffect } from "react";

import useSegmentTrack from "@/hooks/useSegmentTrack";
import { WatchQueryOptions } from "@apollo/client";

type Props = React.DetailedHTMLProps<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
> & {
  children: React.ReactNode;
  segmentProps?: {
    event: string;
    props?: object;
  };
  query?: WatchQueryOptions["query"];
  variables?: WatchQueryOptions["variables"];
  transformer?: <TData, TVariables, TResult>(
    data: TData,
    variables: TVariables,
  ) => TResult;
};

const TrackedLink = ({
  children,
  segmentProps = {
    event: "",
    props: {},
  },
  query,
  variables,
  transformer,
  ...props
}: Props) => {
  const anchor = useRef(null);
  const doSegmentTrack = useSegmentTrack("trackLink");

  useEffect(() => {
    doSegmentTrack(segmentProps.event || `${props.href} Clicked`, {
      query,
      variables,
      transformer,
      element: anchor.current,
      props: {
        ...segmentProps.props,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <a ref={anchor} href={props.href} {...props}>
      {children}
    </a>
  );
};

export default TrackedLink;
